import { useQuery } from '@tanstack/react-query';
import { useMedplum } from '@medplum/react';

export const getPatientQueryKey = (patientId: string) => ['patient', patientId];

export function usePatient(patientId: string | undefined) {
	const medplum = useMedplum();

	return useQuery({
		queryKey: getPatientQueryKey(patientId ?? ''),
		queryFn: () => medplum.readResource('Patient', patientId!),
		enabled: !!patientId,
	});
}
